import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { fakeEllipsis } from '@client/shared/utils/utils/utils';
import DisplayBoxLabel from '@client/components/displayBox/displayBoxLabel/DisplayBoxLabel';
import Image from '@client/components/image/Image';
import DisplayBoxLogo from '@client/components/displayBox/displayBoxLogo/DisplayBoxLogo';
import ReactLink from '@client/components/reactLink/ReactLink';
import { strings } from '@client/localization/Localization';
import { SHORTER_DESCRIPTION_LENGTH } from '@client/shared/js/constants';
import indicators from '@client/shared/js/indicators';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './largeDisplayBox.scss';

class LargeDisplayBox extends PureComponent {
  getPlayButton = () => {
    if (this.props.buttonText)
      return (
        <button
          type="button"
          className={`${themeStyles.btnPrimarySmall} ${styles.button}`}
        >
          <img className={styles.buttonIcon} src={indicators.arrow_black} />
          {this.props.buttonText}
        </button>
      );
  };

  render() {
    const {
      className,
      title,
      description,
      imgSrc,
      alt,
      categoryTitle,
      categoryColor,
      sponsor,
      route,
      numOfEpisodes,
    } = this.props;

    return (
      <div
        className={
          className ? `${styles.displayBox} ${className}` : styles.displayBox
        }
      >
        <ReactLink to={route}>
          <div className={styles.imageContainer}>
            {categoryTitle && (
              <DisplayBoxLabel
                text={categoryTitle}
                backgroundColor={categoryColor}
              />
            )}
            {sponsor && (
              <DisplayBoxLogo logo={sponsor.imageUrl} alt={sponsor.title} />
            )}
            <Image className={styles.image} src={imgSrc} alt={alt} />
            <div className={`${themeStyles.hideOnMobile} ${styles.overlay}`}>
              <div className={styles.textBox}>
                <div
                  className={`${themeStyles.episodesCount} ${styles.episodesCount}`}
                >
                  <span>{numOfEpisodes}</span>
                  <span>{strings.episodesCount}</span>
                </div>
                <div className={`${themeStyles.displayTitle} ${styles.title}`}>
                  {title}
                </div>
                {description && (
                  <div className={themeStyles.displayDescription}>
                    {fakeEllipsis(description, SHORTER_DESCRIPTION_LENGTH)}
                  </div>
                )}
                {this.getPlayButton()}
              </div>
            </div>
          </div>
        </ReactLink>
      </div>
    );
  }
}

LargeDisplayBox.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
  sponsor: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  categoryColor: PropTypes.string,
  categoryTitle: PropTypes.string,
  imgSrc: PropTypes.string,
  alt: PropTypes.string,
  logo: PropTypes.string,
  logoAlt: PropTypes.string,
  route: PropTypes.string,
  numOfEpisodes: PropTypes.number,
  ctaUrl: PropTypes.string,
  buttonText: PropTypes.string,
};

export default LargeDisplayBox;
